// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3utZX";
var _4 = "wrapper_flat-3JKCK";
var _5 = "header-bYDqj";
var _6 = "header_business-1Fi32";
var _7 = "leg-3NZ61";
var _8 = "leg__date-915pr";
var _9 = "closer-2VJiA";
var _a = "body-1mpmk";
var _b = "body_flat-pKBn6";
var _c = "body_canceled-waX9m";
var _d = "footer-278Gg";
var _e = "footer_flat-YpnkS";
var _f = "footer__price-1AVOt";
var _10 = "footer__price_flat-3qG9f";
var _11 = "price__miles-2QbAQ";
var _12 = "currency-2asB_";
var _13 = "miles__taxes-ra_3a";
var _14 = "canceled-27Kq9";
var _15 = "paper-355Qb";
var _16 = "slideBottom__container-1iL_e";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_flat", _5 as "header", _6 as "header_business", _7 as "leg", _8 as "leg__date", _9 as "closer", _a as "body", _b as "body_flat", _c as "body_canceled", _d as "footer", _e as "footer_flat", _f as "footer__price", _10 as "footer__price_flat", _11 as "price__miles", _12 as "currency", _13 as "miles__taxes", _14 as "canceled", _15 as "paper", _16 as "slideBottom__container" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_flat": _4, "header": _5, "header_business": _6, "leg": _7, "leg__date": _8, "closer": _9, "body": _a, "body_flat": _b, "body_canceled": _c, "footer": _d, "footer_flat": _e, "footer__price": _f, "footer__price_flat": _10, "price__miles": _11, "currency": _12, "miles__taxes": _13, "canceled": _14, "paper": _15, "slideBottom__container": _16 }
